import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UiCheckBoxComponent from "../UiCheckBox";
import {
  AppDispatch,
  updateSystemUiModuleComponentClear,
  updateSystemUiModuleComponentRequest,
} from "../../../../../redux";
import { updateSystemUiModuleComponent } from "../../../../../redux/index";

interface Role {
  id?: string;
  name?: string;
}

interface PageComponent {
  id?: string;
  name?: string;
  roleList?: Role[];
}

interface PageUiComponentRoleCheckBoxProps {
  pageComponent: PageComponent;
  role: Role;
  index?: number;
}

const PageUiComponentRoleCheckBox: React.FC<
  PageUiComponentRoleCheckBoxProps
> = ({ pageComponent, role, index }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { result } = useSelector(updateSystemUiModuleComponent);

  const checkboxKey = `${pageComponent.id}_${role.id}`;

  const initialAccess = !!pageComponent?.roleList?.some(
    (r) => r?.id === role.id
  );
  const [hasAccess, setHasAccess] = useState<boolean>(initialAccess);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const next = !!pageComponent?.roleList?.some((r) => r?.id === role.id);
    setHasAccess(next);
  }, [pageComponent, role.id]);

  useEffect(() => {
    if (loading && result?.status === "success") {
      setLoading(false);
      dispatch(updateSystemUiModuleComponentClear());
    }
  }, [result]);

  const onChangePageAccess = (value: boolean) => {
    setHasAccess(value);
    setLoading(true);

    if (value) {
      dispatch(
        updateSystemUiModuleComponentRequest({
          id: pageComponent.id || "",
          data: { roleIdList: [role?.id || ""] },
        })
      );
    } else {
      dispatch(
        updateSystemUiModuleComponentRequest({
          id: pageComponent.id || "",
          data: { removableRoleIdList: [role.id || ""] },
        })
      );
    }
  };

  return (
    <UiCheckBoxComponent
      key={checkboxKey}
      isChecked={hasAccess}
      loading={loading}
      onChange={onChangePageAccess}
      index={index}
    />
  );
};

export default PageUiComponentRoleCheckBox;
